import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { CardVaultPaymentMethodDetailContent } from './CardVaultPaymentMethodDetailContent';

export default function CardVaultTransactionDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <CardVaultPaymentMethodDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
